import React from 'react';
import { useNavigate } from 'react-router-dom';
import './foodToAvoid.css';
import pawImg from '../assets/paw.png';
import buttonStyles from '../components/Buttons.module.css';

const TransitionGuide: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="page-container cream-bg">
      {/* Floating Paw Print Background */}
      <div className="hero-paw-bg">
        <img src={pawImg} className="hero-paw-float paw1" alt="" />
        <img src={pawImg} className="hero-paw-float paw2" alt="" />
        <img src={pawImg} className="hero-paw-float paw3" alt="" />
        <img src={pawImg} className="hero-paw-float paw4" alt="" />
        <img src={pawImg} className="hero-paw-float paw5" alt="" />
        <img src={pawImg} className="hero-paw-float paw6" alt="" />
        <img src={pawImg} className="hero-paw-float paw7" alt="" />
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '2rem 2rem 0' }}>
        <button
          className={`${buttonStyles.antBtn} ${buttonStyles.antBtnSecondary}`}
          style={{ fontSize: '1.08rem', padding: '0.7em 1.6em', borderRadius: '14px', fontWeight: 600 }}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          ← Back
        </button>
      </div>

      <div className="page-intro">
        <h1 className="page-title">How to Safely Transition Your Dog to Homemade Food</h1>
        <div className="page-intro-underline" />
      </div>

      <div className="content-section" style={{margin: '0 auto', padding: '0 0.5rem 1.5rem' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '2rem 2.5rem', boxShadow: '0 4px 12px rgba(44,62,80,0.08)', lineHeight: 1.8 }}>
          
          <p style={{ fontSize: '1.1rem', marginBottom: '2.5rem', color: '#555' }}>
            Switching your dog to homemade food can be a great way to provide fresh ingredients and variety. However, sudden diet changes can upset a dog's digestive system. A gradual transition helps your dog adjust comfortably.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2rem', marginBottom: '1rem', fontWeight: 700 }}>Why a Gradual Transition Matters</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Dogs develop digestive enzymes and gut bacteria that adapt to their regular diet. Changing food too quickly can lead to:
          </p>

          <ul style={{ marginLeft: '2rem', marginBottom: '2rem', color: '#555' }}>
            <li>diarrhea</li>
            <li>vomiting</li>
            <li>gas</li>
            <li>stomach discomfort</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Transitioning slowly allows your dog's digestive system to adapt.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Recommended Transition Schedule</h2>
          
          <p style={{ marginBottom: '1.5rem', color: '#555' }}>
            A gradual transition over 7–10 days works well for most dogs.
          </p>

          <div style={{ overflowX: 'auto', marginBottom: '2rem' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse', 
              border: '2px solid #e5e7eb',
              borderRadius: 8,
              overflow: 'hidden'
            }}>
              <thead>
                <tr style={{ background: '#fffbe6' }}>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #e5e7eb', color: '#b24646', fontWeight: 700 }}>Day</th>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #e5e7eb', color: '#b24646', fontWeight: 700 }}>Current Food</th>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #e5e7eb', color: '#b24646', fontWeight: 700 }}>Homemade Food</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: '#fff' }}>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555', fontWeight: 600 }}>Days 1–2</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>75%</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>25%</td>
                </tr>
                <tr style={{ background: '#f9fafb' }}>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555', fontWeight: 600 }}>Days 3–4</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>50%</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>50%</td>
                </tr>
                <tr style={{ background: '#fff' }}>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555', fontWeight: 600 }}>Days 5–6</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>25%</td>
                  <td style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb', color: '#555' }}>75%</td>
                </tr>
                <tr style={{ background: '#f9fafb' }}>
                  <td style={{ padding: '1rem', color: '#555', fontWeight: 600 }}>Day 7+</td>
                  <td style={{ padding: '1rem', color: '#555' }}>0%</td>
                  <td style={{ padding: '1rem', color: '#555' }}>100%</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p style={{ marginBottom: '2rem', color: '#555', fontStyle: 'italic', background: '#fffbe6', padding: '1rem', borderRadius: 8 }}>
            If your dog has a sensitive stomach, you may want to extend the transition to 10–14 days.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Signs Your Dog Is Adjusting Well</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Most dogs transition smoothly. Positive signs include:
          </p>

          <ul style={{ marginLeft: '2rem', marginBottom: '2rem', color: '#555' }}>
            <li>normal stool consistency</li>
            <li>good appetite</li>
            <li>normal energy levels</li>
            <li>healthy digestion</li>
          </ul>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>If Digestive Upset Occurs</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Mild digestive changes can sometimes happen during a food transition.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>If your dog develops:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>loose stool</li>
            <li>mild gas</li>
            <li>temporary appetite changes</li>
          </ul>

          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Try slowing the transition and staying at the current ratio for a few extra days.
          </p>

          <p style={{ marginBottom: '2rem', color: '#555', fontWeight: 600, background: '#fff3cd', padding: '1rem 1.5rem', borderRadius: 8, borderLeft: '4px solid #ff9800' }}>
            If symptoms are severe or persist, consult a veterinarian.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Tips for a Smooth Transition</h2>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Start with simple recipes</h3>
          
          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Recipes that include easy-to-digest ingredients like:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>chicken</li>
            <li>turkey</li>
            <li>rice</li>
            <li>pumpkin</li>
          </ul>
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            can help dogs transition more comfortably.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Keep portions consistent</h3>
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Feed the same total amount of food your dog normally eats while gradually adjusting the ratio.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Monitor stool quality</h3>
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Your dog's stool is one of the best indicators of how well the transition is going.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Avoid multiple changes at once</h3>
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            If possible, avoid introducing new treats or supplements during the transition period.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Dogs That May Need Extra Care</h2>
          
          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Some dogs may require slower transitions, including:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>dogs with sensitive digestion</li>
            <li>senior dogs</li>
            <li>dogs recovering from illness</li>
            <li>dogs with existing medical conditions</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            For these dogs, a longer transition period is usually helpful.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>After the Transition</h2>
          
          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Once your dog has fully transitioned to homemade food, continue to monitor:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>body weight</li>
            <li>stool quality</li>
            <li>energy levels</li>
            <li>coat condition</li>
          </ul>

          <p style={{ color: '#555' }}>
            These can help ensure your dog is thriving on their new diet.
          </p>

        </div>
      </div>
    </div>
  );
};

export default TransitionGuide;
